import { ListItemText, ListItemTextProps } from '@mui/material'
import React from 'react'

export type WcListItemTextProps = ListItemTextProps

export const WcListItemText = ({children, ...props}: WcListItemTextProps) => (
    <ListItemText {...props}>{children}</ListItemText>
  )